<template>
  <section class="dwse-forms">
    <vl-title v-vl-align:center>
      WSE Formulieren
    </vl-title>

    <section class="dwse-forms__select">
      <div class="dwse-forms__select-wrapper">
        <vl-select
          v-model="selectedFormTag"
          placeholder-text="Kies formulier"
          @change="setSelectedFormTag($event.target.value)">
          <option
            v-for="form in forms"
            :key="form.tag"
            :value="form.tag">
            {{ form.label }}
          </option>
        </vl-select>

        <vl-select
          placeholder-text="Kies taal"
          @input="handleLangChange">
          <option
            v-for="(lang, i) in langs" :key="`forms-lang-${i}`"
            :value="lang">
            {{ lang }}
          </option>
        </vl-select>
      </div>
    </section>

    <vl-u-spacer mod-large />

    <section
      v-if="selectedFormTag"
      class="dwse-component__preview">
      <vl-title tag-name="h2">
        {{ selectedFormLabel }}
      </vl-title>
      <component :is="selectedFormTag" />
    </section>

    <section
      v-else
      class="dwse-component__preview">
      <div v-vl-align:center>
        Geen formulier geselecteerd...
      </div>
    </section>
  </section>
</template>

<script>
export default {
  data: () => ({
    langs: [
      'nl',
      'en',
      'fr'
    ],
    forms: [
      {
        label: 'OVA Simulator',
        tag: 'wse-ova-simulator'
      },
      {
        label: 'ABK Simulator',
        tag: 'wse-abk-simulator'
      },
      {
        label: 'ABK Beroepskaarten Simulator',
        tag: 'wse-abk-beroepskaarten-simulator'
      },
      {
        label: 'VZA Simulator',
        tag: 'wse-vza-simulator'
      },
      {
        label: 'SSB Startbonus Simulator',
        tag: 'wse-ssb-startbonus-simulator'
      },
      {
        label: 'SSB Stagebonus Simulator',
        tag: 'wse-ssb-stagebonus-simulator'
      },
      {
        label: 'Registratie Sportmakelaars',
        tag: 'wse-spm-registratie'
      },
      {
        label: 'AWAP Premie Simulator',
        tag: 'wse-awap-simulator'
      },
      {
        label: 'Leer- en loopbaanRekening Simulator',
        tag: 'wse-llr-simulator'
      },
      {
        label: 'Jobbonus Simulator',
        tag: 'wse-jb-simulator'
      },
      {
        label: 'JobbonusPLUS Simulator',
        tag: 'wse-jb-plus-simulator'
      },
      {
        label: 'OPCH Simulator',
        tag: 'wse-opch-simulator'
      },
      {
        label: 'IMW Simulator',
        tag: 'wse-imw-simulator'
      }
    ],
    selectedFormTag: ''
  }),

  computed: {
    selectedFormLabel() {
      return this.forms.find(form => form.tag === this.selectedFormTag).label;
    }
  },

  mounted() {
    if (this.$route.query.form) {
      this.selectedFormTag = this.$route.query.form;
    }
  },

  methods: {
    handleLangChange(lang) {
      window.location.assign(`/${lang}`);
    },
    setSelectedFormTag(form) {
      this.$router.push({ query: { form } });
      this.selectedFormTag = form;
    }
  }
};
</script>

<style lang="scss" scoped>
.dwse-forms {
  > .vl-title--h1 {
    margin-bottom: 2rem;
  }

  &__select {
    text-align: center;

    &-wrapper {
      display: inline-block;
    }
  }

  .dwse-component {
    &__preview {
      padding: 2em 3em;
      border: 1px solid #e7ebee;
    }
  }
}
</style>
